import Footer from "../ui-components/Footer";
import Header from "../ui-components/Header/Header";
import AppBanner from "../ui-components/app-banner/AppBanner";

function SectionPage() {
  return (
    <div>
      {/* <Header /> */}
      <AppBanner />
      {/* <Footer /> */}
    </div>
  );
}

export default SectionPage;
